import { ApiService } from "./apiService";
import { AddRegistryPatientDto } from "types/dto/AddRegistryPatientDto";
import { RegistryPatientDto } from "types/dto/RegistryPatientDto";


export const createRegistryPatient = async (dto: AddRegistryPatientDto) => {
  const { registryId, patientId, ...payload } = dto;
  return await ApiService.post(`registries/${registryId}/procedures`, { data: payload });
};

export const updateRegistryPatient = async (dto: AddRegistryPatientDto) => {
  const { registryId, patientId, ...payload } = dto;

  return await ApiService.put(`registries/${registryId}/procedures/${patientId}`, { data: payload });
}


export const deleteRegistryPatients = async (dto: RegistryPatientDto) => {
  const { registryId, patientIds } = dto;
  patientIds?.forEach(async id => {
    await ApiService.delete(`registries/${registryId}/procedures/${id}`);
  })
  return 1;
}

export const getRegistryPatientById = async (dto: RegistryPatientDto) => {
  const { registryId, patientId } = dto;
  return await ApiService.get(`registries/${registryId}/procedures/${patientId}`);
}

export const getRegistryPatientImages = async (dto: RegistryPatientDto) => {
  const { data } = await ApiService.get(`registries/${dto.registryId}/procedures/${dto.patientId}/media`);
  return data;
}

export const updateRegistryPatientImage = async (dto: RegistryPatientDto, image: any) => {
  return await ApiService.put(`registries/${dto.registryId}/procedures/${dto.patientId}/media/${image.id}`, image);
}

export const updateRegistryPatientImages = async (dto: RegistryPatientDto, formData: FormData) => {
  return await ApiService.postFormData(`registries/${dto.registryId}/procedures/${dto.patientId}/media`, formData);
}

export const deleteRegistryPatientImage = async (dto: RegistryPatientDto, imageId: number) => {
  const { data } = await ApiService.delete(`registries/${dto.registryId}/procedures/${dto.patientId}/media/${imageId}`);
  return data;
}
